export default __webpack_public_path__ + "static/media/teeshop.095f2ac3.png";